"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _hubspot = _interopRequireDefault(require("hubspot.Interframe"));

var _jQuery = _interopRequireDefault(require("jQuery"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _underscore = require("underscore");

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var _Scopes2 = require("lead-flows-ui/constants/Scopes");

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _I18n = _interopRequireDefault(require("I18n"));

var CURRENT_DYNO_VERSION = 3;
var interframe;

function getOrigin() {
  // IE doesn't support `location.origin`.
  var _document$location = document.location,
      protocol = _document$location.protocol,
      hostname = _document$location.hostname;
  return document.location.origin || protocol + "//" + hostname;
}

var DynoEditorDemoIframe = _react.default.createClass({
  displayName: "DynoEditorDemoIframe",
  propTypes: {
    brandingEnabled: _react.default.PropTypes.bool.isRequired,
    content: _react.default.PropTypes.node,
    dyno: _react.default.PropTypes.object.isRequired,
    gdprStep: _react.default.PropTypes.number,
    handleGDPRChange: _react.default.PropTypes.func,
    handleLoading: _react.default.PropTypes.func,
    handleStateChange: _react.default.PropTypes.func,
    interactionDisabled: _react.default.PropTypes.bool,
    showTryMe: _react.default.PropTypes.bool.isRequired,
    state: _react.default.PropTypes.string
  },
  timeoutTimer: undefined,
  // eslint-disable-line  react/sort-comp
  getDefaultProps: function getDefaultProps() {
    return {
      interactionDisabled: false,
      showTryMe: false,
      handleLoading: _emptyFunction.default
    };
  },
  getInitialState: function getInitialState() {
    return {
      loaded: false,
      errored: false
    };
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.demoIframe." + suffix;
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var _this$props = this.props,
        dyno = _this$props.dyno,
        state = _this$props.state,
        handleLoading = _this$props.handleLoading;
    var iframe = (0, _jQuery.default)(this.refs.demoIframe);
    this.timeoutTimer = setTimeout(this.handleIframeTimeout, 15000);
    handleLoading(true);
    iframe.bind('load', function () {
      clearTimeout(_this.timeoutTimer);

      _this.setState({
        loaded: true,
        errored: false
      });

      interframe = new _hubspot.default(_this.getIframeUrl(), iframe.get(0).contentWindow, true);
      interframe.start();
      (0, _jQuery.default)(interframe).on('message', _this.handleInterframeMessage);
      interframe.postMessage({
        type: 'SETUP_CONFIG',
        config: _this.getConfigMessageBody(dyno),
        state: state
      });
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _this$props2 = this.props,
        dyno = _this$props2.dyno,
        state = _this$props2.state,
        gdprStep = _this$props2.gdprStep,
        handleLoading = _this$props2.handleLoading;

    if (!this.state.loaded) {
      return;
    }

    var oldConfig = this.getDynoConfigMessageBody(dyno);
    var newConfig = this.getDynoConfigMessageBody(nextProps.dyno);
    var delta = (0, _DynoUtils.deltaDynoConfigs)(oldConfig, newConfig);

    if (!(0, _underscore.isEmpty)(delta)) {
      interframe.postMessage({
        type: 'UPDATE_DYNO',
        dyno: delta
      });
    }

    if (state !== nextProps.state) {
      handleLoading(true);
      interframe.postMessage({
        type: 'CHANGE_STATE',
        state: nextProps.state
      });
    }

    if (gdprStep !== nextProps.gdprStep && dyno.legalConsentOptions === nextProps.dyno.legalConsentOptions) {
      interframe.postMessage({
        type: 'CHANGE_GDPR',
        step: nextProps.gdprStep
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (interframe) {
      (0, _jQuery.default)(interframe).off('message');
      interframe.stop();
    }

    this.props.handleLoading(false);
    clearTimeout(this.timeoutTimer);
  },
  getIframeUrl: function getIframeUrl() {
    var origin = getOrigin();
    return origin + "/lead-flows-js/demo.html?parent=" + encodeURIComponent(origin);
  },
  getConfigMessageBody: function getConfigMessageBody(dyno) {
    var brandingEnabled = this.props.brandingEnabled;
    return {
      dyno: this.getDynoConfigMessageBody(dyno),
      isTryMeEnabled: this.props.showTryMe,
      brandingEnabled: brandingEnabled
    };
  },
  getDynoConfigMessageBody: function getDynoConfigMessageBody(dyno) {
    return {
      version: CURRENT_DYNO_VERSION,
      type: dyno.type,
      heading: dyno.heading || '[callout text]',
      description: dyno.description,
      ctaText: dyno.cta || _I18n.default.text('buttonText'),
      formCta: dyno.formCta || _I18n.default.text('buttonText'),
      formDescription: dyno.formDescription,
      showNames: dyno.showNames,
      showPhone: dyno.showPhone,
      color: dyno.color || '#000000',
      imageUrl: dyno.imageResizedUrl,
      completedMessageHtml: dyno.completedMessageHtml || '[thank you message]',
      displayOnMobile: dyno.displayOnMobile,
      locale: dyno.locale,
      legalConsentOptions: dyno.legalConsentOptions,
      formFields: dyno.formFields,
      recaptchaEnabled: dyno.kickbackEmails && dyno.kickbackEmails.length > 0,
      dismissButtonEnabled: dyno.dismissButtonEnabled,
      redirectUrl: dyno.redirectUrl,
      redirectButtonText: dyno.redirectButtonText,
      redirectButtonType: dyno.redirectButtonType,
      calloutButtonType: dyno.calloutButtonType,
      eventDates: dyno.eventDates,
      eventTitle: dyno.eventTitle,
      eventLocation: dyno.eventLocation,
      eventDetails: dyno.eventDetails
    };
  },
  handleIframeTimeout: function handleIframeTimeout() {
    var handleLoading = this.props.handleLoading;
    LOG.error('The dyno editor demo failed to load. Hit timeout of 15 seconds');
    this.setState({
      errored: true
    });
    handleLoading(false);
  },
  handleInterframeMessage: function handleInterframeMessage(event, message) {
    var _this$props3 = this.props,
        gdprStep = _this$props3.gdprStep,
        handleLoading = _this$props3.handleLoading,
        handleGDPRChange = _this$props3.handleGDPRChange;

    if (message.type === 'STATE_CHANGED' && this.props.handleStateChange) {
      this.props.handleStateChange(message.state); // Setup generates two STATE_CHANGED messages we want to wait until setup is done

      if (message._callbackId > 1) {
        handleLoading(false);
      }
    }

    if (handleGDPRChange && message.type === 'GDPR_CHANGED' && gdprStep !== message.state) {
      handleGDPRChange(message.state);
    }
  },
  render: function render() {
    var _this$props4 = this.props,
        content = _this$props4.content,
        dyno = _this$props4.dyno,
        interactionDisabled = _this$props4.interactionDisabled,
        state = _this$props4.state,
        url = _this$props4.url;
    var errored = this.state.errored;

    var isFormStep = state.toLowerCase() === _DynoEditor.STEPS.FORM.toLowerCase();

    var hasGDPR = dyno.legalConsentOptions !== null;
    var interactionDisabledClass = interactionDisabled ? 'interaction-disabled' : '';
    var erroredClass = errored ? 'dyno-editor-demo-iframe--errored' : '';

    if (isFormStep) {
      interactionDisabledClass = hasGDPR ? '' : interactionDisabledClass;
    }

    if (content) {
      return content;
    }

    return _react.default.createElement("div", {
      className: "dyno-editor-demo-content " + erroredClass
    }, _react.default.createElement("iframe", {
      className: interactionDisabledClass,
      src: this.getIframeUrl(url),
      scrolling: "no",
      ref: "demoIframe"
    }), _react.default.createElement(_UILoadingSpinner.default, {
      className: "dyno-editor-demo-iframe__loading " + interactionDisabledClass,
      grow: true
    }), _react.default.createElement("div", {
      className: "dyno-editor-demo-iframe__error"
    }, _react.default.createElement("h4", null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('troubleLoadingDemo')
    })), _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('troubleLoadingDemoMessage')
    }))));
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    brandingEnabled: !(0, _Scopes.hasScope)(state, _Scopes2.LEADIN_NO_BRANDING)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(DynoEditorDemoIframe);

exports.default = _default;
module.exports = exports.default;